/* "Size Chart" button is not focusable */
(function () {
  var CONTAINER_SEL = '.ks-chart-container.ks-container-with-modal, .sizing-chart-container.ks-container-with-modal';
  var TRIGGER_SEL = '.ks-chart-modal-link, .sizing-chart-modal-link, .ks-chart-modal-button, .sizing-chart-modal-button';

  function isHidden(el) {
    if (!(el instanceof Element)) return true;
    if (el.hasAttribute('hidden') || el.getAttribute('aria-hidden') === 'true') return true;
    var style = window.getComputedStyle(el);
    return style.display === 'none' || style.visibility === 'hidden';
  }

  function visibleTrigger(container) {
    var nodes = container.querySelectorAll(TRIGGER_SEL + ', button, a[href], [role="button"]');
    for (var i = 0; i < nodes.length; i++) {
      if (!isHidden(nodes[i])) return nodes[i];
    }
    return null;
  }

  function bindActivate(el, clickTarget) {
    if (el.dataset.lfKsChartKeys) return;
    el.dataset.lfKsChartKeys = 'true';
    el.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ' && event.key !== 'Spacebar') return;
      event.preventDefault();
      (clickTarget || el).click();
    });
  }

  function makeFocusable(el, clickTarget) {
    if (!(el instanceof Element)) return;
    if (el.tagName === 'BUTTON' || (el.tagName === 'A' && el.getAttribute('href'))) {
      if (!el.disabled && el.tabIndex < 0) el.removeAttribute('tabindex');
    } else {
      if (!el.getAttribute('role')) el.setAttribute('role', 'button');
      if (el.tabIndex < 0) el.setAttribute('tabindex', '0');
    }
    if (!el.getAttribute('aria-label') && /size chart/i.test((el.textContent || '').replace(/\s+/g, ' '))) {
      el.setAttribute('aria-label', 'Size Chart');
    }
    bindActivate(el, clickTarget);
  }

  function enhance(el) {
    if (!(el instanceof Element)) return;
    if (el.matches(CONTAINER_SEL)) {
      var trigger = visibleTrigger(el);
      if (trigger) {
        makeFocusable(trigger);
        return;
      }
      var hiddenTrigger = el.querySelector(TRIGGER_SEL + ', button');
      makeFocusable(el, hiddenTrigger || el);
      return;
    }
    makeFocusable(el);
  }

  function scan() {
    document.querySelectorAll(TRIGGER_SEL).forEach(enhance);
    document.querySelectorAll(CONTAINER_SEL).forEach(enhance);
  }

  window.lfA11y.once(scan);
})();

/* Graphic product link (e.g. “Sovella Women's PF Black”) is not keyboard-triggerable */
(function () {
  var SELECTOR = '.cbb-frequently-bought-product-image-link';

  function enhance(el) {
    if (!(el instanceof Element)) return;
    var href = el.getAttribute('href') || el.getAttribute('data-href');
    if (href) el.setAttribute('href', href);
    if (!el.getAttribute('role')) el.setAttribute('role', 'link');
    if (el.tabIndex < 0) el.setAttribute('tabindex', '0');
    var item = el.closest('.cbb-frequently-bought-product');
    var title = (item && item.querySelector('.cbb-frequently-bought-selector-link')) ||
      (href && document.querySelector('.cbb-frequently-bought-selector-link[href="' + href.replace(/"/g, '') + '"]'));
    var name = title ? title.textContent.replace(/\s+/g, ' ').trim() : '';
    if (name) el.setAttribute('aria-label', name);

    if (el.dataset.lfCbbImageLink) return;
    el.dataset.lfCbbImageLink = 'true';
    el.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ' && event.key !== 'Spacebar') return;
      event.preventDefault();
      if (href) {
        window.location.href = href;
        return;
      }
      el.click();
    });
  }

  function scan() {
    document.querySelectorAll(SELECTOR).forEach(enhance);
  }

  window.lfA11y.once(scan);
})();

/* Variant radios (size/color/width): focusing a native radio checks it
   and reloads the product. Keep radios out of the tab order, roam focus
   on the labels, and only commit on pointer/click / Space / Enter.

   Do not clear the click flag with setTimeout(0) from pointerdown — the
   browser often flushes that timer between pointerdown and click, which
   made size taps look like “focus-only” changes and get reverted. */
(function () {
  var RADIO_SEL = 'variant-picker input.opt-btn[type="radio"]';
  var LABEL_SEL = 'variant-picker .opt-label';
  var allowCommit = false;

  function groupOf(el) {
    return el && el.closest ? el.closest('.option-selector, fieldset') : null;
  }

  function radiosIn(group) {
    return Array.prototype.slice.call(group.querySelectorAll('input.opt-btn[type="radio"]'));
  }

  function labelFor(radio) {
    if (!radio) return null;
    if (radio.labels && radio.labels[0]) return radio.labels[0];
    return radio.id ? document.querySelector('label[for="' + radio.id + '"]') : null;
  }

  function radioFor(label) {
    if (!label) return null;
    if (label.htmlFor) return document.getElementById(label.htmlFor);
    var prev = label.previousElementSibling;
    return prev && prev.matches && prev.matches('input.opt-btn') ? prev : null;
  }

  function labelsIn(group) {
    return radiosIn(group).map(labelFor).filter(Boolean);
  }

  function rememberChecked(group) {
    var checked = radiosIn(group).find(function (radio) { return radio.checked; });
    if (checked && checked.id) group.dataset.lfCheckedId = checked.id;
  }

  function restoreChecked(group, radio) {
    radio.checked = false;
    var prev = group.dataset.lfCheckedId && document.getElementById(group.dataset.lfCheckedId);
    if (prev) prev.checked = true;
  }

  function syncTabStops(group, focusedLabel) {
    var radios = radiosIn(group);
    if (!radios.length) return;
    radios.forEach(function (radio) {
      radio.tabIndex = -1;
    });
    var labels = labelsIn(group);
    var selected = radios.find(function (radio) { return radio.checked; });
    var current = focusedLabel || (selected && labelFor(selected)) || labels[0];
    labels.forEach(function (label) {
      var radio = radioFor(label);
      label.setAttribute('role', 'radio');
      label.setAttribute('aria-checked', radio && radio.checked ? 'true' : 'false');
      label.tabIndex = label === current ? 0 : -1;
    });
    rememberChecked(group);
  }

  function moveFocus(group, delta) {
    var labels = labelsIn(group);
    if (!labels.length) return;
    var index = labels.indexOf(document.activeElement);
    if (index < 0) {
      index = labels.findIndex(function (label) { return label.tabIndex === 0; });
    }
    if (index < 0) index = 0;
    var next = labels[(index + delta + labels.length) % labels.length];
    syncTabStops(group, next);
    next.focus();
  }

  function markPointerCommit(radio) {
    if (!radio) return;
    radio.dataset.lfPointerCommit = '1';
    allowCommit = true;
  }

  function clearPointerCommit(radio) {
    allowCommit = false;
    if (radio) delete radio.dataset.lfPointerCommit;
  }

  function commit(radio, label) {
    if (!radio || radio.checked) return;
    markPointerCommit(radio);
    radio.checked = true;
    radio.dispatchEvent(new Event('input', { bubbles: true }));
    radio.dispatchEvent(new Event('change', { bubbles: true }));
    clearPointerCommit(radio);
    var group = groupOf(radio);
    if (group) syncTabStops(group, label || labelFor(radio));
  }

  function context(target) {
    if (!(target instanceof Element)) return null;
    var radio = target.closest(RADIO_SEL);
    var label = target.closest(LABEL_SEL);
    if (!radio && label) radio = radioFor(label);
    if (!label && radio) label = labelFor(radio);
    var group = groupOf(radio || label);
    if (!group || !radio) return null;
    return { radio: radio, label: label, group: group };
  }

  function enhance(group) {
    if (!(group instanceof Element)) return;
    if (!group.querySelector('input.opt-btn')) return;
    var focused = labelsIn(group).find(function (label) {
      return label === document.activeElement;
    });
    syncTabStops(group, focused);
  }

  function scan() {
    document.querySelectorAll('variant-picker .option-selector').forEach(enhance);
  }

  document.addEventListener(
    'focusin',
    function (event) {
      var radio = event.target && event.target.matches && event.target.matches(RADIO_SEL)
        ? event.target
        : null;
      if (radio) {
        var label = labelFor(radio);
        if (label && document.activeElement === radio) {
          label.focus();
        }
        return;
      }

      var vkItem = event.target && event.target.closest
        ? event.target.closest('variant-king-combined-listing li.swatch-view-item, variant-king-combined-listing [role="radio"]')
        : null;
      if (!vkItem) return;
      var vkGroup = vkItem.closest('ul.swatch-view, [role="radiogroup"]');
      if (!vkGroup || !vkGroup._lfCommitted) return;
      requestAnimationFrame(function () {
        vkGroup.querySelectorAll('li.swatch-view-item, [role="radio"]').forEach(function (item) {
          var on = item === vkGroup._lfCommitted;
          item.setAttribute('aria-checked', on ? 'true' : 'false');
        });
      });
    },
    true
  );

  document.addEventListener(
    'change',
    function (event) {
      var radio = event.target && event.target.matches && event.target.matches(RADIO_SEL)
        ? event.target
        : null;
      if (!radio || allowCommit || radio.dataset.lfPointerCommit === '1') {
        if (radio && radio.checked) {
          var group = groupOf(radio);
          if (group) rememberChecked(group);
        }
        if (radio) clearPointerCommit(radio);
        return;
      }
      var group = groupOf(radio);
      if (!group) return;
      event.stopImmediatePropagation();
      event.preventDefault();
      restoreChecked(group, radio);
    },
    true
  );

  document.addEventListener(
    'pointerdown',
    function (event) {
      var ctx = event.target && context(event.target);
      if (!ctx) return;
      markPointerCommit(ctx.radio);
    },
    true
  );

  /* VoiceOver / delayed taps often fire click without a live pointer flag. */
  document.addEventListener(
    'click',
    function (event) {
      var ctx = event.target && context(event.target);
      if (!ctx) return;
      markPointerCommit(ctx.radio);
    },
    true
  );

  document.addEventListener(
    'pointerup',
    function (event) {
      var ctx = event.target && context(event.target);
      if (!ctx) return;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          clearPointerCommit(ctx.radio);
        });
      });
    },
    true
  );

  document.addEventListener(
    'pointercancel',
    function (event) {
      var ctx = event.target && context(event.target);
      if (ctx) clearPointerCommit(ctx.radio);
    },
    true
  );

  document.addEventListener(
    'keydown',
    function (event) {
      var ctx = event.target && context(event.target);
      if (!ctx) return;
      var key = event.key;

      if (key === 'ArrowRight' || key === 'ArrowDown') {
        event.preventDefault();
        event.stopImmediatePropagation();
        moveFocus(ctx.group, 1);
        return;
      }
      if (key === 'ArrowLeft' || key === 'ArrowUp') {
        event.preventDefault();
        event.stopImmediatePropagation();
        moveFocus(ctx.group, -1);
        return;
      }
      if (key === 'Home') {
        event.preventDefault();
        event.stopImmediatePropagation();
        var first = labelsIn(ctx.group)[0];
        syncTabStops(ctx.group, first);
        if (first) first.focus();
        return;
      }
      if (key === 'End') {
        event.preventDefault();
        event.stopImmediatePropagation();
        var labels = labelsIn(ctx.group);
        var last = labels[labels.length - 1];
        syncTabStops(ctx.group, last);
        if (last) last.focus();
        return;
      }
      if (key === ' ' || key === 'Spacebar' || key === 'Enter') {
        event.preventDefault();
        event.stopImmediatePropagation();
        commit(ctx.radio, ctx.label);
      }
    },
    true
  );

  window.lfA11y.once(scan);
})();

/* "Review" overlay is missing role and label (should be dialog "Review") */
(function () {
  var SELECTOR = '.jdgm-modal__content';

  function enhance(el) {
    if (!(el instanceof Element)) return;
    if (el.hasAttribute('hidden') || el.getAttribute('aria-hidden') === 'true') return;
    var style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden') return;

    var dialog = el.matches('.jdgm-modal__content') ? el : (el.querySelector('.jdgm-modal__content') || el);
    if (dialog.getAttribute('role') !== 'dialog') dialog.setAttribute('role', 'dialog');
    dialog.setAttribute('aria-modal', 'true');
    if (dialog.getAttribute('aria-label') !== 'Review') dialog.setAttribute('aria-label', 'Review');
    if (dialog.tabIndex < 0) dialog.setAttribute('tabindex', '-1');
  }

  function scan() {
    document.querySelectorAll(SELECTOR).forEach(enhance);
  }

  window.lfA11y.once(scan);
})();

/* Opening a product quick-view dialog does not move/trap focus */
(function () {
  var opener = null;

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest && event.target.closest('.quickbuy-toggle');
    if (toggle) opener = toggle;
  }, true);

  document.addEventListener('on:quickbuy:after-open', function (event) {
    var root = event.target && event.target.closest ? event.target.closest('.quickbuy-container') : null;
    if (!root) root = document.querySelector('.product-block.expanded .quickbuy-container');
    if (!root || typeof window.trapFocus !== 'function') return;
    var closeBtn = root.querySelector('.close-detail');
    window.trapFocus(root, closeBtn || root);
  });

  function release() {
    if (typeof window.removeTrapFocus === 'function') {
      window.removeTrapFocus(opener && document.contains(opener) ? opener : null);
    } else if (opener && document.contains(opener)) {
      opener.focus();
    }
    opener = null;
  }

  document.addEventListener('on:quickbuy:after-close', release);

  document.addEventListener('click', function (event) {
    if (!(event.target.closest && event.target.closest('.close-detail'))) return;
    setTimeout(release, 50);
  }, true);
})();

/* Product info disclosures: the theme now renders plain summary elements
   (APG disclosure pattern — native button + expanded state). Strip any stale
   tab/tablist overlay semantics; a summary[role="tab"] without a conformant
   tablist ancestor mis-announces in AT, which QA kept flagging. */
(function () {
  function scan() {
    document.querySelectorAll('.product-info-accordion summary, .disclosure summary.disclosure__title').forEach(function (summary) {
      if (summary.getAttribute('role') === 'tab') summary.removeAttribute('role');
      summary.removeAttribute('aria-selected');
    });
    document.querySelectorAll('[data-lf-product-tabs]').forEach(function (wrap) {
      wrap.removeAttribute('role');
      wrap.removeAttribute('aria-orientation');
    });
    document.querySelectorAll('.product-info-accordion .disclosure__panel[role="tabpanel"]').forEach(function (panel) {
      panel.removeAttribute('role');
    });
  }

  window.lfA11y.once(scan);
})();

/* Selected size that is out of stock is not announced */
(function () {
  function soldOut() {
    return (window.theme && theme.strings && theme.strings.noStock) || 'Sold out';
  }

  function optionName(el) {
    var raw = '';
    if (el.matches('input.opt-btn')) raw = el.value || '';
    else if (el.getAttribute('data-value')) raw = el.getAttribute('data-value');
    else raw = el.textContent || '';
    return raw.replace(/\s+/g, ' ').replace(new RegExp(',?\\s*' + soldOut().replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'ig'), '').trim();
  }

  function setName(el, unavailable) {
    var name = optionName(el);
    if (!name) return;
    var full = unavailable ? name + ', ' + soldOut() : '';
    if (full) el.setAttribute('aria-label', full);
    else if (el.getAttribute('aria-label') && new RegExp(soldOut(), 'i').test(el.getAttribute('aria-label'))) {
      el.removeAttribute('aria-label');
    }
  }

  function markLabel(radio) {
    var label = radio.labels && radio.labels[0];
    if (!label) return;
    var unavailable = radio.classList.contains('is-unavailable');
    setName(radio, unavailable);
    setName(label, unavailable);
    var hint = label.querySelector('.lf-sold-out-name');
    if (unavailable && !hint) {
      hint = document.createElement('span');
      hint.className = 'visually-hidden lf-sold-out-name';
      hint.textContent = soldOut();
      label.appendChild(hint);
    } else if (!unavailable && hint) {
      hint.remove();
    }
  }

  function scan() {
    document.querySelectorAll('variant-picker input.opt-btn').forEach(markLabel);
    document.querySelectorAll('variant-picker .custom-select__option').forEach(function (opt) {
      setName(opt, opt.classList.contains('is-unavailable'));
    });
    document.querySelectorAll('variant-picker .custom-select__btn').forEach(function (btn) {
      var root = btn.closest('.custom-select, .option-selector');
      var selected = root && root.querySelector('.custom-select__option[aria-selected="true"]');
      setName(btn, !!(selected && selected.classList.contains('is-unavailable')));
    });
  }

  document.addEventListener('on:variant:change', function () {
    setTimeout(scan, 50);
  });
  document.addEventListener('change', function (event) {
    if (event.target.closest && event.target.closest('variant-picker')) setTimeout(scan, 50);
  });
  window.lfA11y.once(scan);
})();

/* Available quantity (e.g. “4 in stock”) is not announced when the size changes */
(function () {
  function region() {
    var el = document.getElementById('lf-inventory-status');
    if (el) return el;
    el = document.createElement('div');
    el.id = 'lf-inventory-status';
    el.className = 'visually-hidden';
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');
    el.setAttribute('aria-atomic', 'true');
    document.body.appendChild(el);
    return el;
  }

  function visibleInventory() {
    var nodes = document.querySelectorAll('.product-info-block.product-inventory:not(.product-inventory--small)');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.closest('cart-drawer, .cart-drawer, .cart-item, #cartform')) continue;
      if (el.hasAttribute('hidden') || el.hidden) continue;
      var style = window.getComputedStyle(el);
      if (style.display === 'none' || style.visibility === 'hidden') continue;
      return el;
    }
    return null;
  }

  function inventoryText() {
    var root = visibleInventory();
    if (!root) return '';
    var status = root.querySelector('.product-inventory__status');
    return ((status || root).textContent || '').replace(/\s+/g, ' ').trim();
  }

  function announce(text) {
    if (!text) return;
    var el = region();
    el.textContent = '';
    setTimeout(function () { el.textContent = text; }, 20);
  }

  function nameSelectedSize(text) {
    var group = document.querySelector('variant-picker fieldset[data-option="Size"], variant-picker .option-selector[data-option="Size"]');
    if (!group || !text) return;
    var radio = group.querySelector('input.opt-btn:checked');
    if (!radio) return;
    var label = radio.labels && radio.labels[0];
    var size = (radio.value || '').replace(/\s+/g, ' ').trim();
    if (!size) return;
    var full = size + ', ' + text;
    radio.setAttribute('aria-label', full);
    if (label) label.setAttribute('aria-label', full);
  }

  function update() {
    var text = inventoryText();
    if (!text) {
      var addBtn = document.querySelector('.js-product-form [name="add"]');
      if (addBtn && addBtn.disabled) {
        text = ((addBtn.textContent || '').replace(/\s+/g, ' ').trim()) || 'Sold out';
      }
    }
    announce(text);
    nameSelectedSize(text);
  }

  document.addEventListener('on:variant:change', function () {
    setTimeout(update, 60);
  });
})();

/* Focus is obscured by the Size Chart overlay (and not trapped) */
(function () {
  var inerted = [];
  var OPEN_TRIGGERS = '.ks-chart-modal-link, .sizing-chart-modal-link, .ks-chart-modal-button, .sizing-chart-modal-button, .size-chart-link, open-or-scroll-to, .ks-chart-container.ks-container-with-modal';

  function overlay() {
    if (document.documentElement.classList.contains('kiwi-sizing-modal-visible')) {
      var kiwi = document.querySelector('.kiwi-sizing-modal');
      if (kiwi) return kiwi;
    }
    return document.querySelector('modal-dialog.modal--for-size-guide[open], modal-dialog[id^="size-chart-"][open]');
  }

  function clearInert() {
    inerted.forEach(function (el) {
      el.inert = false;
      el.removeAttribute('aria-hidden');
    });
    inerted = [];
  }

  function applyInert(dialog) {
    clearInert();
    Array.prototype.forEach.call(document.body.children, function (child) {
      if (child === dialog || child.contains(dialog)) return;
      child.inert = true;
      child.removeAttribute('aria-hidden');
      inerted.push(child);
    });
  }

  function focusables(dialog) {
    return Array.prototype.filter.call(
      dialog.querySelectorAll('a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])'),
      function (el) {
        if (el.disabled) return false;
        var style = window.getComputedStyle(el);
        return style.display !== 'none' && style.visibility !== 'hidden' && el.getClientRects().length > 0;
      }
    );
  }

  function activate() {
    var dialog = overlay();
    if (!dialog) {
      if (inerted.length) clearInert();
      return;
    }
    if (dialog.getAttribute('role') !== 'dialog') dialog.setAttribute('role', 'dialog');
    if (!dialog.getAttribute('aria-modal')) dialog.setAttribute('aria-modal', 'true');
    var lbl = dialog.getAttribute('aria-label');
    if (!lbl || /^dialog$/i.test(lbl.trim())) dialog.setAttribute('aria-label', 'Size Chart');
    applyInert(dialog);
    if (!dialog.contains(document.activeElement)) {
      var close = dialog.querySelector('.ks-modal-close, .modal__close-btn, .js-close-modal, [aria-label="Close"]');
      if (close) close.focus();
      else {
        if (dialog.tabIndex < 0) dialog.setAttribute('tabindex', '-1');
        dialog.focus();
      }
    }
  }

  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;
    if (event.target.closest(OPEN_TRIGGERS + ', .ks-modal-close, .js-close-modal, .modal__close-btn')) {
      setTimeout(activate, 150);
      /* Kiwi mounts its modal content asynchronously; re-check later too */
      setTimeout(activate, 500);
      setTimeout(activate, 1100);
      return;
    }
    /* Any other click (e.g. the backdrop) may have closed the dialog —
       release inert so the page does not stay hidden from AT. */
    if (inerted.length) {
      setTimeout(function () {
        if (!overlay()) clearInert();
      }, 150);
    }
  }, true);

  document.addEventListener('keydown', function (event) {
    var dialog = overlay();
    if (event.key === 'Escape') {
      setTimeout(activate, 50);
      return;
    }
    if (event.key !== 'Tab' || !dialog) return;
    var list = focusables(dialog);
    if (!list.length) {
      event.preventDefault();
      dialog.focus();
      return;
    }
    var first = list[0];
    var last = list[list.length - 1];
    var active = document.activeElement;
    if (event.shiftKey && (active === first || !dialog.contains(active))) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && (active === last || !dialog.contains(active))) {
      event.preventDefault();
      first.focus();
    }
  }, true);

  window.lfA11y.once(activate, { priority: 'critical' });
})();

/* Size-guide table captions (“Men's Size Guide”, “Women's Size Guide”) are not announced */
(function () {
  function captionFor(table) {
    var wrap = table.closest('.ks-table-content-wrapper');
    var prev = wrap && wrap.previousElementSibling;
    while (prev && !prev.classList.contains('ks-html-content')) {
      prev = prev.previousElementSibling;
    }
    if (prev) return prev.textContent.replace(/\s+/g, ' ').trim();
    var heading = table.closest('.size-guide-table-container') && table.closest('.size-guide-table-container').querySelector('h3, .h5');
    if (heading) return heading.textContent.replace(/\s+/g, ' ').trim();
    return '';
  }

  function scan() {
    document.querySelectorAll('.ks-table, .size-guide-table').forEach(function (table) {
      var name = captionFor(table);
      if (!name) return;
      var caption = table.querySelector('caption');
      if (!caption) {
        caption = document.createElement('caption');
        caption.className = 'visually-hidden';
        table.insertBefore(caption, table.firstChild);
      }
      caption.textContent = name;
      table.setAttribute('aria-label', name);
    });
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest && event.target.closest('.ks-chart-modal-link, .sizing-chart-modal-link, .size-chart-link, open-or-scroll-to')) {
      setTimeout(scan, 200);
    }
  }, true);
  window.lfA11y.once(scan);
})();
